import { Dropdown, Label } from '@silverfort/sf-components';
import { FC, useCallback } from 'react';
import { useReportsDrawer } from '../../ReportsDrawerContext';

interface ModulesFieldProps {
    modules: string[];
    setModules: (modules: string[]) => void;
}

const ModulesField: FC<ModulesFieldProps> = ({ modules, setModules }) => {
    const { availableModules } = useReportsDrawer();

    const handleChange = useCallback(
        (value) => {
            if (!value) return setModules([]);
            setModules(Array.isArray(value) ? value : [value]);
        },
        [setModules]
    );

    return (
        <div className="flex flex-col gap-2">
            <Label text="Module" tooltipInfo="Specify the modules to include in the report" />
            <div className="flex flex-col p-4 gap-4 border border-sf-gray-100 rounded-lg">
                <Dropdown
                    variant="trigger"
                    items={availableModules}
                    size="large"
                    className="w-full"
                    multiple
                    text="Select Modules"
                    selectedItems={modules}
                    onChange={handleChange}
                    fullMenuWidth
                />
            </div>
        </div>
    );
};

export default ModulesField;
